import {
  BiometricIdentityVerificationRequest,
  BiometricIdentityVerificationRequestStatus,
  InsuranceMonitor,
  PayeeRequirement,
  RequirementType,
  SharedFileRequest
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsInsuranceMonitorInProgress } from "../modules/InsuranceCoverage/selectors/selectorIsInsuranceMonitorInProgress";
import { getPayerSharedFileRequirementIsUploadAvailable } from "../modules/SharedFile/configs/helpers/getPayerSharedFileRequirementIsUploadAvailable";
import { RequirementAdditionalData } from "../types";

import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";

export const selectorIsInstructionsModalAvailable = (
  requirement: PayeeRequirement,
  dataSource: RequirementAdditionalData
) => {
  if (requirement.type === RequirementType.DOCUMENT_UPLOAD) {
    const sharedFile = dataSource as SharedFileRequest;

    if (
      selectorIsSharedFileNotNoneContext(sharedFile.contextType) &&
      getPayerSharedFileRequirementIsUploadAvailable(requirement, sharedFile)
    ) {
      return true;
    }
  }

  if (requirement.type === RequirementType.INSURANCE_COVERAGE) {
    const insuranceMonitor = dataSource as InsuranceMonitor;

    // the same ["Pending", "Monitoring"] pair v1 checked (still being
    // evaluated)
    if (selectorIsInsuranceMonitorInProgress(insuranceMonitor)) {
      return true;
    }
  }

  if (requirement.type === RequirementType.BIOMETRIC_IDENTITY_VERIFICATION) {
    const identityVerification =
      dataSource as BiometricIdentityVerificationRequest;

    // The same single "Pending" status v1 checked (anything not Complete/Failed).
    if (
      identityVerification.status ===
      BiometricIdentityVerificationRequestStatus.PENDING
    ) {
      return true;
    }
  }

  return false;
};
